import { fetchCourses } from "../api/courses";
import { fetchKholasehVaziat } from "../api/kholasehVaziats";
import { fetchHistories } from "../api/histories";
import { fetchZirmajmoeh } from "../api/zirmajmoeh";
import { fetchVarizha } from "../api/varizha";
import { fetchDariaftha } from "../api/dariaftha";




export const getCourses = () => {
    return async (dispatch) => {
        const courses = await fetchCourses();
        await dispatch({ type: "INIT", payload: courses });
    };
};

export const getHistories = () => {
    return async (dispatch) => {
        const historyes = await fetchHistories();
        await dispatch({ type: "HSTRI", payload: historyes });
    };
};

export const getZirmajmoeh = () => {
    return async (dispatch) => {
        const zirmajmoehs = await fetchZirmajmoeh();
        await dispatch({ type: "MJMH", payload: zirmajmoehs });
    };
};

export const getKholasehVaziat = (fltr) => {
    return async (dispatch) => {
        const kholasehVaziat = await fetchKholasehVaziat(fltr);
        await dispatch({ type: "KHLSH", payload: kholasehVaziat });
    };
};

export const getVarizha = (fltr) => {
    return async (dispatch) => {
        const varizhas = await fetchVarizha(fltr);
        await dispatch({ type: "VRZHA", payload: varizhas });
    };
};

export const getDariaftha = (fltr) => {
    return async (dispatch) => {
        const dariafts = await fetchDariaftha(fltr);
        await dispatch({ type: "DRFTHA", payload: dariafts });
    };
};


export const userAction = (user) => {
    return async (dispatch) => {
        await dispatch({ type: "USER", payload: user });
    };
};
